import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, useTheme } from '@mui/material';
import React from 'react';
import { Badge } from 'src/components/atoms';
import {
  pendingMitigationColorResolver,
  publishedColorResolver,
} from 'src/components/atlas/organisms/helpers/sharedStatusColorResolvers';
import { CategoryConfigurationStatus } from 'src/graphql/generated';

interface CategoryStatusBadgeProps {
  status: CategoryConfigurationStatus;
}

const STATUS_LABELS: Record<CategoryConfigurationStatus, string> = {
  [CategoryConfigurationStatus.Active]: 'Active',
  [CategoryConfigurationStatus.FormRequired]: 'Form required',
  [CategoryConfigurationStatus.Inactive]: 'Inactive',
};

export const CategoryStatusBadge: React.FC<CategoryStatusBadgeProps> = ({
  status,
}) => {
  const { tokens } = useTheme<LensTheme>();

  const palette: Record<
    CategoryConfigurationStatus,
    { background: string; text: string }
  > = {
    [CategoryConfigurationStatus.Active]: {
      background: publishedColorResolver(tokens).backgroundColor,
      text: publishedColorResolver(tokens).color,
    },
    [CategoryConfigurationStatus.FormRequired]: {
      background: pendingMitigationColorResolver(tokens).backgroundColor,
      text: pendingMitigationColorResolver(tokens).color,
    },
    [CategoryConfigurationStatus.Inactive]: {
      background: tokens.core.color.concrete['90'].value,
      text: tokens.semantic.color.type.default.value,
    },
  };

  return (
    <Box sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
      <Badge
        variant="custom"
        text={STATUS_LABELS[status]}
        color={palette[status].text}
        background-color={palette[status].background}
        data-testid={`category-status-badge-${status}`}
      />
    </Box>
  );
};
